import { useSandpack } from "@codesandbox/sandpack-react";
import { styled } from "@stitches/react";
import Editor from "@monaco-editor/react";
import blackboard from "../assets/blackboard.json";
import monoindustrial from "../assets/monoindustrial.json";
import dracula from "../assets/dracula.json";
import { useEffect, useRef } from "react";

const CodeEditorContainer = styled("div", {
  width: "100%",
  height: "100%",

  ".decorationsOverviewRuler": {
    display: "none",
  },
});

function CodeEditor({ theme, playPreviewSuccess }) {
  const { sandpack } = useSandpack();
  const { files, activePath, updateCurrentFile } = sandpack;
  const previewFunction = useRef(playPreviewSuccess);

  const code = files[activePath].code;

  let ext = activePath.split(".")[1];
  ext = ext === "js" ? "javascript" : ext;

  function handleEditorWillMount(monaco) {
    monaco.editor.defineTheme("monoindustrial", {
      ...monoindustrial,
    });

    monaco.editor.defineTheme("blackboard", {
      ...blackboard,
    });

    monaco.editor.defineTheme("dracula", {
      ...dracula,
    });
  }

  useEffect(() => {
    previewFunction.current = playPreviewSuccess;
  }, [playPreviewSuccess]);

  useEffect(() => {
    function updateLocalStorage() {
      localStorage.setItem("files", JSON.stringify(files));
    }

    updateLocalStorage();
  }, [files]);

  // useEffect(() => {

  // }, [theme]);

  function handleEditorDidMount(editor, monaco) {
    editor.addCommand(
      monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_S,
      function (e) {
        editor.trigger("", "editor.action.formatDocument");
        previewFunction.current();
        return;
      }
    );
  }

  return (
    <CodeEditorContainer>
      <Editor
        language={ext}
        theme={theme}
        value={code}
        options={{
          minimap: {
            enabled: false,
            renderCharacters: false,
          },
          folding: false,
          scrollbar: {
            alwaysConsumeMouseWheel: false,
            useShadows: false,
            verticalScrollbarSize: "8px",
            horizontalScrollbarSize: "8px",
          },
          automaticLayout: true,
          formatOnType: true,
          codeLens: false,
          wordWrap: true,
          hideCursorInOverviewRuler: true,
          overviewRulerBorder: false,
          lightbulb: false,
          fontSize: "14px",
          fontFamily: "Fira Code, Monaco, Courier",
          renderLineHighlightOnlyWhenFocus: true,
          fontLigatures: true,
          tabSize: 2,
        }}
        onChange={(code) => {
          updateCurrentFile(code);
        }}
        beforeMount={handleEditorWillMount}
        onMount={handleEditorDidMount}
      />
    </CodeEditorContainer>
  );
}

export default CodeEditor;
